import React from 'react';
import { JobFormCard } from './basic/JobFormCard';
import { ExecutionDetailResponseBody } from '@lct-jobs/core';
import validator from '@rjsf/validator-ajv8';

export interface JobInputProps {
  jobExecution?: ExecutionDetailResponseBody;
}

export const JobInputBox: React.FC<JobInputProps> = (props) => {
  const execution = props.jobExecution;
  return (
    <JobFormCard
      title="Job Input"
      schema={execution?.inputSchema ?? {}}
      formData={execution?.jobInput}
      validator={validator}
    />
  );
};
